import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://knhgdgssjiesgquvghke.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'sb_publishable_h4Yuy5juywC-b8lctk55Fg_LxEocnlK';

if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storage: localStorage,
        debug: true
    },
    realtime: {
        log_level: 'debug'
    },
    global: {
        fetch: (url: RequestInfo | URL, init?: RequestInit) => {
            console.log('Supabase Fetch:', url, init);
            return fetch(url, init);
        }
    }
});
